module.exports = __webpack_public_path__ + "img/Timor-Leste.b38576fa.png";